import React from "react";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/xoi_grilled_chicken.png";
import { Helmet } from "react-helmet-async";
import useMetaTracking from "../hooks/useMetaTracking";

function ChickenXoi() {
  useMetaTracking("ViewContent", {
    content_name: "Chicken Xoi (Xôi Gà)",
    content_category: "Regular Menu",
    content_ids: ["chicken_xoi"],
    content_type: "savory_xoi",
    value: 6.0,
    currency: "USD",
  });

  const descriptionText =
    "Fragrant Vietnamese sticky rice (xôi) paired with grilled chicken, traditional Vietnamese meat loaf (chả lụa), sweet Chinese sausage, and crispy shallots.";

  return (
    <>
      <Helmet>
        <title>Chicken Xôi (Xôi Gà) | Đông Hưng Viên Bakery</title>
        <meta name="description" content={descriptionText} />
        <meta
          property="og:title"
          content="Chicken Xôi (Xôi Gà) | Đông Hưng Viên Bakery"
        />
        <meta property="og:description" content={descriptionText} />
        <meta property="og:image" content={CardImg} />
      </Helmet>

      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f" }}>
        <Navbar />

        <ProductCard
          cardImg={CardImg}
          titleHead="Chicken Xôi"
          titleSubHead="Xôi Gà · $6.00 each"
          detailBody={descriptionText}
          detailBodyBr={
            <>
              Contains: soy, wheat
            </>
          }
          ProductCardBtn="View All Xôi"
          btnLink="/xoi"
        />

        <Footer />
      </Box>
    </>
  );
}

export default ChickenXoi;
